export const EDITABLE_FIELD_ATTR = "data-invoice-editable-trigger"
export const FOCUS_TARGET_ATTR = "data-invoice-focus-target"

export const EDITABLE_FIELD_SELECTOR = `[${EDITABLE_FIELD_ATTR}]`
export const FOCUS_TARGET_SELECTOR = `[${FOCUS_TARGET_ATTR}]`
